"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHasTopicQuery = void 0;
const react_query_1 = require("@tanstack/react-query");
const Activities_1 = __importDefault(require("../../../js/stores/Activities"));
const useHasTopicQuery = (topic, license, queryOptions = {}) => (0, react_query_1.useQuery)({
    staleTime: 5 * 60 * 1000,
    ...queryOptions,
    queryKey: ['license', license.externalId, topic],
    queryFn: () => Activities_1.default.api
        .hasTopic({
        topic,
        referenceId: license.externalId,
    })
        .then(() => true)
        .catch((error) => {
        if (error?.response?.status === 404) {
            return false;
        }
        return Promise.reject(error);
    }),
});
exports.useHasTopicQuery = useHasTopicQuery;
